// extracted by mini-css-extract-plugin
export default {"custom_Iframe":"styles_custom_Iframe__-8vr0"};